import { PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as changeCase from 'change-case';
import { FuseTranslationLoaderService } from '../../services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "../../services/translation-loader.service";
var TranslateStorageMovementTypePipe = /** @class */ (function () {
    function TranslateStorageMovementTypePipe(translateService, translationLoaderService) {
        this.translateService = translateService;
        this.translationLoaderService = translationLoaderService;
        this.translationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    TranslateStorageMovementTypePipe.prototype.transform = function (value) {
        return this.translateService.instant("TRANSLATE_STORAGE_MOVEMENT_TYPE." + changeCase.constantCase(String(value)));
    };
    TranslateStorageMovementTypePipe.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TranslateStorageMovementTypePipe_Factory() { return new TranslateStorageMovementTypePipe(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.FuseTranslationLoaderService)); }, token: TranslateStorageMovementTypePipe, providedIn: "root" });
    return TranslateStorageMovementTypePipe;
}());
export { TranslateStorageMovementTypePipe };
